import { createContext } from 'react'
import type { Context } from 'react'
import type { TickerStateType } from 'storeContext/reducers/ticker'
import type { TickerDispatchType } from 'storeContext/actions/ticker'

export type TickerContextValueType = {
  state: TickerStateType
  dispatch: TickerDispatchType
}

// Preserve the legacy raw-state default while typing the provider value.
export const createTickerContext = (initialState: TickerStateType) =>
  createContext(initialState) as unknown as Context<TickerContextValueType>
